namespace TabAurous.Administration {
    export interface FreightForm {
        FreightCode: Serenity.StringEditor;
        FreightName: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        UserId: Serenity.StringEditor;
        Password: Serenity.StringEditor;
        ApiEndpoint: Serenity.StringEditor;
        ApiKey: Serenity.StringEditor;
        ClientSecret: Serenity.StringEditor;
    }

    export class FreightForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Freight';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FreightForm.init)  {
                FreightForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(FreightForm, [
                    'FreightCode', w0,
                    'FreightName', w0,
                    'LedgerId', w1,
                    'UserId', w0,
                    'Password', w0,
                    'ApiEndpoint', w0,
                    'ApiKey', w0,
                    'ClientSecret', w0
                ]);
            }
        }
    }
}
